var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('Footer',{attrs:{"first-section":_vm.firstSection,"second-section":_vm.secondSection,"copyright-section":_vm.copyrightSection}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }